<template>
  <div id="custom-field-container">
    <ValidationProvider
      :rules="{ required: custom_field.required }"
      v-slot="{ errors, valid, validated, required }"
      :name="custom_field.label"
      slim
      v-for="(custom_field, index) of custom_fields"
      :key="index"
    >
      <b-form-group
        v-if="custom_field.type !== 'external'"
        :invalid-feedback="errors[0]"
        :state="required && validated ? valid : undefined"
        :label="custom_field.type !== 'checkbox' ? custom_field.label : null"
        :label-class="{ 'label-required': required }"
        class="form-group"
      >
        <p v-if="custom_field.description && custom_field.type !== 'checkbox'">
          {{ custom_field.description }}
        </p>

        <b-form-input
          v-if="custom_field.type === 'text'"
          v-model="custom_fields[index].value"
          :name="custom_field.label"
          :state="required && validated ? valid : undefined"
          :placeholder="custom_field.label"
          :value="custom_field.value"
        />

        <b-form-textarea
          v-if="custom_field.type === 'textarea'"
          v-model="custom_fields[index].value"
          :name="custom_field.label"
          :state="required && validated ? valid : undefined"
          :placeholder="custom_field.label"
          :value="custom_field.value"
        />

        <template v-if="custom_field.type === 'radio'">
          <b-form-radio-group
            v-model="custom_fields[index].value"
            :options="custom_field.options"
            :state="required && validated ? valid : undefined"
            :name="custom_field.label.replace(/\s|\W/g, '')"
          />
        </template>

        <b-form-select
          v-if="custom_field.type === 'select'"
          v-model="custom_fields[index].value"
          :name="custom_field.label"
          :state="required && validated ? valid : undefined"
          :options="custom_field.options"
        >
        </b-form-select>

        <template v-if="custom_field.type === 'checkbox'">
          <b-form-checkbox
            v-model="custom_fields[index].value"
            :name="custom_field.label.replace(/\s|\W/g, '')"
            :state="required && validated ? valid : undefined"
            value="true"
            unchecked-value="false"
          >
            {{ custom_field.label }}
          </b-form-checkbox>
          <p v-if="custom_field.description">{{ custom_field.description }}</p>
        </template>
      </b-form-group>
    </ValidationProvider>
  </div>
</template>

<script>
/* ============
 * Checkout/Customer Component
 * ============
 *
 * Gives an idea how components work.
 */
import { mapState, mapGetters } from "vuex";
import { sync } from "vuex-pathify";

export default {
  /**
   * The name of the component.
   */
  name: "CustomFields",

  /**
   * The computed properties that the component can use.
   */
  computed: {
    ...mapState({
      cart: (state) => state.cart,
      customer: "customer",
      custom_fields: "custom_fields",
      requires: "requires",
    }),
    ...mapGetters({
      loading: "getLoading",
    }),
    customer_first_name: sync("customer@first_name"),
    customer_last_name: sync("customer@last_name"),
    customer_email: sync("customer@email"),
    marketing_optin: sync("customer@marketing_optin"),
  },
};
</script>
